import React from 'react';
import { updateGlobalFormConfig, FormConfig, Hint } from '@ver-uds/uswds-react';

updateGlobalFormConfig((config: FormConfig) => {
  return {
    ...config,
    requiredLabel: <Hint variant="decorative">(required)</Hint>,
  };
});
